export type Tab = 'analysis' | 'repo' | 'device'

interface Props {
  tab: Tab
  onChange: (tab: Tab) => void
  /** The device tab exists in the app only; a browser has no sockets to reach the logger */
  device: boolean
}

/** The bottom tab bar: Analysis, My repo and (in the app) My device. */
export default function TabBar({ tab, onChange, device }: Props) {
  const tabs: { id: Tab; label: string; icon: React.ReactNode }[] = [
    { id: 'analysis', label: 'Analysis', icon: <ChartIcon /> },
    { id: 'repo', label: 'My repo', icon: <RepoIcon /> },
    ...(device ? [{ id: 'device' as Tab, label: 'My device', icon: <DeviceIcon /> }] : []),
  ]
  return (
    <nav className="tabbar" aria-label="Sections">
      {tabs.map((t) => (
        <button
          key={t.id}
          className={`tab${tab === t.id ? ' active' : ''}`}
          aria-current={tab === t.id ? 'page' : undefined}
          onClick={() => onChange(t.id)}
        >
          {t.icon}
          <span>{t.label}</span>
        </button>
      ))}
    </nav>
  )
}

const svg = {
  viewBox: '0 0 24 24',
  width: 24,
  height: 24,
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

function ChartIcon() {
  return (
    <svg {...svg}>
      <path d="M3 20h18M4 16l5-6 4 3 7-8" />
    </svg>
  )
}
function RepoIcon() {
  return (
    <svg {...svg}>
      <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    </svg>
  )
}
function DeviceIcon() {
  return (
    <svg {...svg}>
      <rect x="7" y="3" width="10" height="18" rx="2" />
      <path d="M11 17h2M4 8a9 9 0 0 1 0 8M20 8a9 9 0 0 0 0 8" />
    </svg>
  )
}
